import copy from "copy-to-clipboard";

/**
 * Copy text to clipboard with cross-browser and mobile device support
 * @param text - The text to copy to clipboard
 * @param options - Optional configuration for copying
 * @returns Promise that resolves to true if successful, false otherwise
 */
export const copyToClipboard = async (
  text: string,
  options?: {
    debug?: boolean;
    message?: string;
    format?: string;
  }
): Promise<boolean> => {
  try {
    // Try modern Clipboard API first (works on most modern browsers)
    if (navigator.clipboard && window.isSecureContext) {
      await navigator.clipboard.writeText(text);
      return true;
    }

    // Fallback to copy-to-clipboard library (works on older browsers and iOS)
    const success = copy(text, {
      debug: options?.debug,
      message: options?.message,
      format: options?.format as "text/html" | "text/plain" | undefined,
    });

    return success;
  } catch (error) {
    console.error("Failed to copy to clipboard:", error);
    return false;
  }
};

/**
 * Copy text to clipboard and show a toast notification
 * @param text - The text to copy
 * @param successMessage - Message to show on success
 * @param errorMessage - Message to show on error
 * @param showToast - Function to show toast notifications
 */
export const copyToClipboardWithToast = async (
  text: string,
  successMessage: string = "Копирано в клипборда!",
  errorMessage: string = "Грешка при копиране",
  showToast?: (message: string, severity: "success" | "error") => void
): Promise<boolean> => {
  const success = await copyToClipboard(text);

  if (showToast) {
    if (success) {
      showToast(successMessage, "success");
    } else {
      showToast(errorMessage, "error");
    }
  }

  return success;
};
